<template>
  <div class="row g-0 align-items-center">
    <div class="col-md-4">
      <div>
        <p class="mb-sm-0">
          Showing
          <strong>{{ startItem }}</strong>
          to
          <strong>{{ endItem }}</strong>
          of
          <strong>{{ totalItems }}</strong>
          entries
        </p>
      </div>
    </div>
    <div class="col-md-8">
      <div class="float-sm-end">
        <ul class="pagination mb-sm-0 d-flex flex-wrap">
          <li class="page-item" :class="{ disabled: selectedPage === 1 }">
            <a :href="generatePageLink(selectedPage - 1)" class="page-link" @click.prevent="changePage(selectedPage - 1)">
              <i class="mdi mdi-chevron-left"></i>
            </a>
          </li>
          <li v-for="(page, index) in visiblePages" :key="index" class="page-item mb-1" :class="{ active: page === selectedPage, disabled: page === '...' }">
            <span v-if="page === '...'" class="page-link">...</span>
            <a v-else :href="generatePageLink(page)" class="page-link" @click.prevent="changePage(page)">{{ page }}</a>
          </li>
          <li class="page-item" :class="{ disabled: selectedPage === totalPages }">
            <a :href="generatePageLink(selectedPage + 1)" class="page-link" @click.prevent="changePage(selectedPage + 1)">
              <i class="mdi mdi-chevron-right"></i>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalItems: {
      type: Number,
      required: true,
    },
    perPage: {
      type: Number,
      default: 10,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    baseUrl: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedPage: this.currentPage > 0 ? this.currentPage : 1,
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.perPage)
    },
    startItem() {
      return (this.selectedPage - 1) * this.perPage + 1
    },
    endItem() {
      return Math.min(this.selectedPage * this.perPage, this.totalItems)
    },
    visiblePages() {
      const pages = []
      const total = this.totalPages

      if (total <= 10) {
        for (let i = 1; i <= total; i++) {
          pages.push(i)
        }
      } else {
        const left = 5
        const right = total - 4

        if (this.selectedPage < left) {
          // Show first 5 and last 5
          for (let i = 1; i <= 5; i++) pages.push(i)
          pages.push('...')
          for (let i = total - 4; i <= total; i++) pages.push(i)
        } else if (this.selectedPage > right) {
          // Show first 5 and last 5
          for (let i = 1; i <= 5; i++) pages.push(i)
          pages.push('...')
          for (let i = total - 4; i <= total; i++) pages.push(i)
        } else {
          // Middle sliding window of 5 pages + first and last 5
          for (let i = 1; i <= 2; i++) pages.push(i)
          pages.push('...')
          for (let i = this.selectedPage; i < this.selectedPage + 5 && i <= total; i++) {
            pages.push(i)
          }
          if (this.selectedPage + 5 < total - 1) {
            pages.push('...')
            for (let i = total - 1; i <= total; i++) pages.push(i)
          }
        }
      }

      return pages
    },
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.selectedPage = page
        this.$emit('page-changed', page)
      }
    },
    generatePageLink(page) {
      return `${this.baseUrl}?page=${page - 1}&size=${this.perPage}`
    },
  },
}
</script>
